import { render, staticRenderFns } from "./pcModule4.vue?vue&type=template&id=6e998fc1&scoped=true"
import script from "./pcModule4.vue?vue&type=script&lang=js"
export * from "./pcModule4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e998fc1",
  null
  
)

export default component.exports